"use client";
import { useEffect, useMemo, useState } from "react";

export const useBreakpoint = () => {
	const breakpoints = {
		sm: 576,
		md: 768,
		lg: 992,
		xl: 1200,
		xxl: 1400,
		ultrawide: 1800,
	};
	const [breakpoint, setBreakpoint] = useState("");

	useEffect(() => {
		const handleResize = () => {
			const width = window.innerWidth;
			if (width < breakpoints.sm) {
				setBreakpoint("sm");
			} else if (width < breakpoints.md) {
				setBreakpoint("md");
			} else if (width < breakpoints.lg) {
				setBreakpoint("lg");
			} else if (width < breakpoints.xl) {
				setBreakpoint("xl");
			} else if (width < breakpoints.xxl) {
				setBreakpoint("xxl");
			} else {
				setBreakpoint("ultrawide");
			}
		};
		handleResize();
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	const breakpointSmallerThan = (bp: string) => {
		// @ts-ignore
		return breakpoints[breakpoint] < breakpoints[bp];
	};

	const isMobile = useMemo(
		() => breakpoint === "sm" || breakpoint === "md",
		[breakpoint]
	);

	return { breakpoint, breakpointSmallerThan, isMobile };
};
